import { useTheme } from "next-themes";
import NextNProgress from "nextjs-progressbar";

const ProgressWrapper = () => {
  const { theme } = useTheme();
  return <NextNProgress color={theme === "light" ? "black" : "white"} />;
};

export default ProgressWrapper;
